<style lang="stylus">
    .zoom-con
        width 215px
        height 36px
        position absolute
        right 10px
        bottom 24px
        display flex
        justify-content space-around
        align-items center
        padding 10px 16px
        z-index 9
        background var(--bg-color-tertiary)
        border 0.5px solid var(--border-color-box-4)
        box-shadow var(--box-shadow-color-floatTool-lockbox)
        border-radius 6px
        color var(--text-color-primary)
        user-select none

        .zc-minus
            width 16px
            height 16px
            transition all 0.2s ease-in-out

            svg
                width 16px
                height 16px
                color var(--svg-color-gray-42)
            &:hover
                color var(--bg-color-float-tool-icon-hover)

        .zc-add
            width 16px
            height 16px
            transition all 0.2s ease-in-out

            svg
                width 16px
                height 16px

            &:hover
                color var(--bg-color-float-tool-icon-hover)

        .zc-per
            width 30px
            height 16px
            line-height 16px
            font-size 12px
            user-select none
            float left
            transition all 0.2s ease-in-out

        .zc-range
            -webkit-appearance none
            -moz-appearance none
            height 3px
            width 96px
            margin 0 4px
            // background linear-gradient(rgba(66, 66, 66, 1), rgba(66, 66, 66, 1)) no-repeat
            background: var(--bg-color-print-page-bottom-zoom-input);
            outline: none;
            transition: 0.1s;
            background-image: linear-gradient(var(--text-color-primary),var(--text-color-primary));
            background-size 20% 100%
            background-repeat: no-repeat;
            border-radius: 5px;

            &:focus
                outline none

            &::-webkit-slider-runnable-track
                height 3px
                border-radius 4px

            &::-webkit-slider-thumb
                -webkit-appearance none
                -moz-appearance none
                height 13px
                width 13px
                border-radius 50%
                background-color var(--bg-color-zoom-slider-thumb);
                border 2px solid var(--border-color-zoom-slider);
                position relative
                top -5px
                transition all 0.3s



            &::-moz-range-thumb
                -moz-appearance none
                height 13px
                width 13px
                border-radius 50%
                background-color #9eb3d2
                position relative
                top -5px
                transition all 0.3s

    .zoom-con .ivu-input-number
        width 45px
        border 0
        font-size 12px
        .ivu-input-number-handler-wrap, .ivu-input-number-input
            background-color var(--bg-color-tertiary)

    .zoom-con .ivu-input-number .ivu-input-number-handler-wrap
        display none
</style>

<template>
    <div class="zoom-con" id="zoom-id">
        <div class="zc-minus" @mousedown="minusDown" @mouseup="minusUp">
            <iconSymbol name="math-minus"></iconSymbol>
        </div>
        <input ref="zcRange" class="zc-range" type="range" step="1" min="12" max="200" v-model="rangeNum" @input="scrolRange" />
        <div class="zc-add" @mousedown="addDown" @mouseup="addUp">
            <iconSymbol name="math-add"></iconSymbol>
        </div>
        <div ref="preNum">
            <InputNumber
                :min="0"
                :max="999"
                @on-blur="preChange"
                v-model="numValue"
                :formatter="(value) => `${value}%`"
                :parser="(value) => value.replace('%', '')"
            ></InputNumber>
        </div>
    </div>
</template>

<script>
    export default {
        name: "",

        components: {},
        props: ["value"],
        inject: ["EDMathUI"],
        data() {
            return {
                numValue: 0,
                minusEvent: "",
                addEvent: "",
            };
        },
        computed: {
            rangeNum: {
                get() {
                    this.numValue = Math.round((this.value / 40) * 100);
                    return this.value;
                },
                set(val) {
                    this.numValue = Math.round((val / 40) * 100);
                    this.$emit("setValue", val);
                },
            },
        },
        watch: {
            rangeNum(val) {
                if (val) {
                    this.updateRange();
                }
            },
        },
        methods: {
            scrolRange() {
                this.updateRange();
            },
            updateRange() {
                const dom = this.$refs.zcRange;
                let range = this.rangeNum / 200;
                dom.style.setProperty("background-size", `${range * 100}% 100%`);
            },
            // 鼠标点下减号
            minusDown() {
                //执行第一次点击事件
                if (this.rangeNum <= 16) {
                    this.rangeNum = 12;
                } else {
                    this.rangeNum = parseInt(this.rangeNum) - 4;
                }
                this.minusEvent = setInterval(() => {
                    if (this.rangeNum <= 16) {
                        this.rangeNum = 12;
                    } else {
                        this.rangeNum = parseInt(this.rangeNum) - 4;
                    }
                    this.updateRange();
                }, 150);
            },
            // 鼠标松开减号
            minusUp() {
                clearInterval(this.minusEvent);
            },
            // 鼠标点下加号
            addDown() {
                //执行第一次点击事件
                if (this.rangeNum >= 196) {
                    this.rangeNum = 200;
                } else {
                    this.rangeNum = parseInt(this.rangeNum) + 4;
                }
                this.addEvent = setInterval(() => {
                    if (this.rangeNum >= 196) {
                        this.rangeNum = 200;
                    } else {
                        this.rangeNum = parseInt(this.rangeNum) + 4;
                    }
                }, 150);
            },
            // 鼠标松开加号
            addUp() {
                clearInterval(this.addEvent);
            },
            // 字体大小设置框失去焦点后的设置
            preChange() {
                if (this.numValue <= 30) {
                    this.numValue = 30;
                    let val = Math.round((this.numValue / 100) * 40);
                    this.$emit("setValue", val);
                } else if (this.numValue >= 500) {
                    this.numValue = 500;
                    let val = Math.round((this.numValue / 100) * 40);
                    this.$emit("setValue", val);
                } else {
                    let val = Math.round((this.numValue / 100) * 40);
                    this.$emit("setValue", val);
                }
            },
        },
        mounted() {
            let num1 = this.$refs.preNum;
            // 输入完字体大小的设置值后 点击Enter键让编辑区获取到焦点
            num1.addEventListener("keypress", (event) => {
                event.key == "Enter" ? this.EDMathUI.view.focus() : "";
            });
            this.numValue = Math.round((this.rangeNum / 40) * 100);
        },
    };
</script>
